module.exports = __webpack_public_path__ + "img/img-modal.11e83358.svg";